import { usePublicLanguage } from '../../public-site/PublicLanguage';
import { useState, useEffect } from 'react';
import { Snackbar, Button, Link } from '@mui/material';
import Cookies from 'js-cookie';

export default function CookieConsent() {
  const { t, href } = usePublicLanguage();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = Cookies.get('cookieConsent');
    if (!hasAccepted) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    // Set cookie consent for 1 year
    Cookies.set('cookieConsent', 'true', { expires: 365 });
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          maxWidth: '600px',
          p: 1,
        },
      }}
      message={
        <span>
          {t(
            'This website uses cookies to enhance your experience. By continuing to use this site, you agree to our use of cookies.',
          )}
          <Link
            href={href('/privacy-policy/')}
            target="_blank"
            color="text.primary"
            sx={{ ml: 1 }}
            aria-label={t('Learn more about our privacy policy')}
          >
            {t('Learn more about our privacy policy')}
          </Link>
        </span>
      }
      action={
        <Button
          color="success"
          size="small"
          onClick={handleAccept}
          sx={{
            fontWeight: 'bold',
            minWidth: '100px',
          }}
        >
          {t('Accept')}
        </Button>
      }
    />
  );
}
